export const HCI_CODE_REGEX = /^\d{2}[A-Z]\d{4}$/;

function validateHciCode(value) {
	return HCI_CODE_REGEX.test(value);
}

export default validateHciCode;
